import { css } from '@emotion/css'

export default {
  root: css`
    font-size: 0.9rem;
    font-weight: normal;
    color: #bb1a0f;
  `,
}
